import React, { useRef, useEffect } from "react"
import styled from "@emotion/styled"
import Input from "../../ui/Input"
import { Row, ActionText } from "./elements"
import Button from "../../ui/Button"

const Container = styled.div`
  width: 100%;
`

const IdentifyStep = ({
  showPassword,
  password,
  email,
  failed,
  onSetHeader,
  onCheckEmail,
  onLogin,
  onForgot,
  onFieldChange,
}) => {
  const emailRef = useRef(null)
  const passRef = useRef(null)

  useEffect(() => {
    onSetHeader(showPassword ? "Welcome back" : "Sign up or create an account")
    if (emailRef) {
      emailRef.current.focus()
    }
    if (passRef && showPassword) {
      passRef.current.focus()
    }
  }, [emailRef, passRef, showPassword])

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (showPassword) {
        onLogin()
      } else {
        onCheckEmail()
      }
    }
  }

  return (
    <Container>
      {showPassword && (
        <Row pt="1rem">
          <div className="small">Enter your password</div>
        </Row>
      )}
      {failed && (
        <Row pt="1rem">
          <div className="small danger">
            Sorry we could not recognize your password
          </div>
        </Row>
      )}
      <Row>
        <Input
          refFunc={emailRef}
          className="input"
          maxLength="50"
          placeholder={"Enter your email"}
          name="email"
          value={email}
          onChange={onFieldChange}
          onKeyPress={handleKeyDown}
        />
      </Row>
      {showPassword && (
        <Row>
          <div className="input">
            <Input
              refFunc={passRef}
              password
              className="input"
              maxLength="50"
              placeholder={"Enter your password"}
              name="password"
              value={password}
              onChange={onFieldChange}
              onKeyPress={handleKeyDown}
            />
            <ActionText onClick={onForgot}>I forgot my password</ActionText>
          </div>
        </Row>
      )}
      <Row pt="6px">
        <Button onClick={showPassword ? onLogin : onCheckEmail}>
          {showPassword ? "Login" : "Next"}
        </Button>
      </Row>
    </Container>
  )
}

export default IdentifyStep
